// boot/bootLIM.js
import moment from "moment";
import { mergeIfEmpty } from "./utils";

export const bootLIM = ({ prev }) => {
    const entradaDefault = moment().startOf("day").format("YYYY-MM-DD 00:00");
    const saidaDefault = moment(entradaDefault).add(1, "year").startOf("day").format("YYYY-MM-DD 00:00");

    const patch = {
        entrada: entradaDefault,
        saida: saidaDefault,
        multa: Number(2).toFixed(2),
        juros: Number(1).toFixed(2),
        diaVencimento: "15",
        condominio: "Locador",
        iptu: "Locador",
        contrato: "Proprietário",
        energia: "Locatário",
        agua: "Locatário",
        locacao: "Comercial",
    };

    // ✅ só preenche campos vazios (não destrói)
    return mergeIfEmpty(prev, patch);
};
